import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { postOrganizationInterop } from '../../../../data/admin'
import { OrganizationInterop } from '../../../../model/OrganizationInterop'
import { addValid } from '../../../../store/message'
import { useActionDispatch } from '../../../utils'
import { organizationInteropKeys } from './organizationInterop.keys'
import { InteropUserFriendlyError, mapInteropApiErrorToUi } from './organizationInteropError.mapper'

export const usePostOrganizationInterop = () => {
  const valid = useActionDispatch(addValid)
  const navigate = useNavigate()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (variables: Partial<OrganizationInterop>) => {
      const apiResponse = await postOrganizationInterop(variables)
      const { data, ok } = apiResponse

      if (!data || !ok) {
        throw new InteropUserFriendlyError(mapInteropApiErrorToUi(apiResponse))
      }
      return data
    },
    onSuccess: (organization) => {
      valid('Organisation interop creee')
      queryClient.refetchQueries({ queryKey: organizationInteropKeys.lists })
      queryClient.setQueryData(organizationInteropKeys.detail(organization.code), organization)
      navigate(`/admin/interop/organizations/${organization.code}`)
    },
  })
}
